import useEventRequiredTerms from './useEventRequiredTermsList';

export default function useNeedsToAgreeEventTerms() {
  return !!useEventRequiredTerms().length;
}
